import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import {BlockUIModule} from 'primeng/blockui';
import { CalendarModule } from 'primeng/calendar';
import { CaptchaModule } from 'primeng/captcha';
import { CheckboxModule } from 'primeng/checkbox';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { EditorModule } from 'primeng/editor';
import { InputMaskModule } from 'primeng/inputmask';
import {InputNumberModule} from 'primeng/inputnumber';
import { InputSwitchModule } from 'primeng/inputswitch';
import { InputTextModule } from 'primeng/inputtext';
import { MessageModule } from 'primeng/message';
import { MessagesModule } from 'primeng/messages';
import {OverlayPanelModule} from 'primeng/overlaypanel';
import { PasswordModule } from 'primeng/password';
import {ProgressSpinnerModule} from 'primeng/progressspinner';
import { RadioButtonModule } from 'primeng/radiobutton';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import {SidebarModule} from 'primeng/sidebar';
import { TableModule } from 'primeng/table';
import { ToastModule } from 'primeng/toast';
import { TooltipModule } from 'primeng/tooltip';
import { CookieService } from 'ngx-cookie-service';
import { AccelaCheckboxInputComponent } from './components/accela-checkbox-input/accela-checkbox-input.component';
import { AccelaDateInputComponent } from './components/accela-date-input/accela-date-input.component';
import { AccelaDropdownInputComponent } from './components/accela-dropdown-input/accela-dropdown-input.component';
import { AccelaEmailInputComponent } from './components/accela-email-input/accela-email-input.component';
import { AccelaFEINInputComponent } from './components/accela-fein-input/accela-fein-input.component';
import { AccelaPasswordInputComponent } from './components/accela-password-input/accela-password-input.component';
import { AccelaPhoneInputComponent } from './components/accela-phone-input/accela-phone-input.component';
import { AccelaSeparatorComponent } from './components/accela-separator/accela-separator.component';
import { AccelaSsnInputComponent } from './components/accela-ssn-input/accela-ssn-input.component';
import { AccelaTextInputComponent } from './components/accela-text-input/accela-text-input.component';
import { AccelaSecurityAnswerInputComponent } from './components/accela-security-answer-input/accela-security-answer-input.component';
import { AccelaZipInputComponent } from './components/accela-zip-input/accela-zip-input.component';
import { AlertMessageComponent } from './components/alert-message/alert-message.component';
import { FormDebuggerComponent } from './components/form-debugger/form-debugger.component';
import { PageLayoutDisplayComponent } from './components/page-layout-display/page-layout-display.component';
import { AccelaSearchBoxInputComponent } from './components/accela-search-box-input/accela-search-box-input.component';
import { AccelaButtonPrimaryComponent } from './components/accela-button-primary/accela-button-primary.component';
import { AccelaButtonCreateComponent } from './components/accela-button-create/accela-button-create.component';
import { AccelaButtonSecondaryComponent } from './components/accela-button-secondary/accela-button-secondary.component';
import { AccelaButtonDeleteComponent } from './components/accela-button-delete/accela-button-delete.component';
import { ContactTypeSelectComponent } from './components/contact-type-select/contact-type-select.component';
import { AccelaRadioGroupComponent } from './components/accela-radio-group/accela-radio-group.component';
import { TrustHtmlPipe } from 'src/app/pipes/trustHtml.pipe';
import { SessionCapModelService } from './services/session-cap-model.service';
import { SearchService } from './services/search.service';
import { HttpErrorHandler } from './services/error-handler.service';
import { AccelaNumberInputComponent } from './components/accela-number-input/accela-number-input.component';
import { AdminPageLayoutComponent } from './components/admin-page-layout/admin-page-layout.component';
import { SectionTitleComponent } from './components/section-title/section-title.component';
import { ConditionBadgeComponent } from './components/condition-badge/condition-badge.component';
import { AAExpressionService } from './services/aaexpression-service.service';
import { ProgressSpinnerComponent } from './components/progress-spinner/progress-spinner.component';
import { SectionInstructionsComponent } from './components/section-instructions/section-instructions.component';
import { SearchPageLayoutComponent } from './components/search-page-layout/search-page-layout.component';
import { AccelaTooltipDirective } from 'src/app/directives/accela-tooltip.directive';
import { AccelaTimepickerInputComponent } from './components/accela-timepicker-input/accela-timepicker-input.component';
import { AccelaTextareaInputComponent } from './components/accela-textarea-input/accela-textarea-input.component';
import { AccelaMoneyInputComponent } from './components/accela-money-input/accela-money-input.component';
import { SharedDataService } from 'src/app/services/shared-data-service.service';
import { CustomScriptInjectionService } from './services/custom-script-injection.service';
import { InputTrimDirective } from 'src/app/directives/input-trim.directive';
import { SsoService } from './services/sso.service';

@NgModule({
    declarations: [
        AccelaCheckboxInputComponent,
        AccelaDateInputComponent,
        AccelaDropdownInputComponent,
        AccelaEmailInputComponent,
        AccelaFEINInputComponent,
        AccelaNumberInputComponent,
        AccelaPasswordInputComponent,
        AccelaPhoneInputComponent,
        AccelaSeparatorComponent,
        AccelaSsnInputComponent,
        AccelaTextInputComponent,
        AccelaSecurityAnswerInputComponent,
        AccelaZipInputComponent,
        AdminPageLayoutComponent,
        AlertMessageComponent,
        AccelaSearchBoxInputComponent,
        AccelaButtonPrimaryComponent,
        AccelaButtonCreateComponent,
        AccelaButtonSecondaryComponent,
        AccelaButtonDeleteComponent,
        AccelaRadioGroupComponent,
        ConditionBadgeComponent,
        ContactTypeSelectComponent,
        FormDebuggerComponent,
        PageLayoutDisplayComponent,
        ProgressSpinnerComponent,
        SearchPageLayoutComponent,
        SectionInstructionsComponent,
        SectionTitleComponent,
        TrustHtmlPipe,
        AccelaTooltipDirective,
        AccelaTimepickerInputComponent,
        AccelaTextareaInputComponent,
    AccelaMoneyInputComponent,
    InputTrimDirective,
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        ButtonModule,
        BlockUIModule,
        CalendarModule,
        CaptchaModule,
        CheckboxModule,
        DialogModule,
        DropdownModule,
        EditorModule,
        InputMaskModule,
        InputNumberModule,
        InputSwitchModule,
        InputTextModule,
        MessageModule,
        MessagesModule,
        OverlayPanelModule,
        PasswordModule,
        ProgressSpinnerModule,
        RadioButtonModule,
        ScrollPanelModule,
        SidebarModule,
        TableModule,
        ToastModule,
        TooltipModule,
    ],
    exports: [
        AccelaButtonPrimaryComponent,
        AccelaButtonSecondaryComponent,
        AccelaButtonCreateComponent,
        AccelaButtonSecondaryComponent,
        AccelaButtonDeleteComponent,
        AccelaCheckboxInputComponent,
        AccelaDateInputComponent,
        AccelaDropdownInputComponent,
        AccelaEmailInputComponent,
        AccelaFEINInputComponent,
        AccelaPasswordInputComponent,
        AccelaPhoneInputComponent,
        AccelaSeparatorComponent,
        AccelaSsnInputComponent,
        AccelaTextInputComponent,
        AccelaSecurityAnswerInputComponent,
        AccelaRadioGroupComponent,
        AccelaSearchBoxInputComponent,
        AccelaZipInputComponent,
        AccelaTimepickerInputComponent,
        AccelaTextareaInputComponent,
        AdminPageLayoutComponent,
        AlertMessageComponent,
        ConditionBadgeComponent,
        ContactTypeSelectComponent,
        FormDebuggerComponent,
        PageLayoutDisplayComponent,
        ProgressSpinnerComponent,
        SearchPageLayoutComponent,
        SectionInstructionsComponent,
        SectionTitleComponent,
        AccelaTooltipDirective,
      TrustHtmlPipe,
      InputTrimDirective
    ],
    providers: [
        AAExpressionService,
        CookieService,
        CustomScriptInjectionService,
        SsoService,
        SearchService,
        SessionCapModelService,
        SharedDataService,
        HttpErrorHandler,
    ]
})
export class SharedModule{}
